import { z } from 'zod';

const transformNullToUndefined = <T>(value: T) => value ?? undefined;

export type Signer = z.infer<typeof signerSchema>;

export const signerSchema = z.object({
  key: z.string(),
  name: z.string().nullable().optional().transform(transformNullToUndefined),
  documentation: z.string().nullable().optional().transform(transformNullToUndefined),
  birthday: z.string().nullable().optional().transform(transformNullToUndefined),
  email: z.string().nullable().optional().transform(transformNullToUndefined),
  phoneNumber: z.string().nullable(),
  hasDocumentation: z.boolean(),
  hasUser: z.boolean().default(false),
  federalDataConfirmed: z.boolean().default(false),
});
